<template>
  <div class="agreement-layout">
    <h1>{{ title }}</h1>
    <p v-html="content"></p>
  </div>
</template>
<script>
import { httpOpen } from "../../scripts/network.js";
export default {
  data() {
    return {
      title: "",
      content: "",
    };
  },
  async mounted() {
    try {
      //   let id = this.$route;
      let id = this.$route.query.id;
      let code = this.$route.query.code;
      const body = {};
      if (id) {
        body.CardSysNo = id;
      }
      if (code) {
        body.ActivationCode = code;
      }
      const ret = await httpOpen("/WuYouCard/GetServiceClause", {
        type: "post",
        body: body,
      });
      if (ret.Status) {
        this.title = ret.Data.ServiceClauseName;
        this.content = ret.Data.ServiceClauseContent;
      }
      console.log(ret);
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
<style lang="less" scoped>
.agreement-layout{
    p{
        margin: 16px;
    }
}
</style>
